import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "locale", "localeMessages", "prefixCls", "size", "ratio"];
import * as React from 'react';
import _get from 'lodash/get';
import _merge from 'lodash/merge';
import ConfigContext, { ConfigConsumer, ConfigProvider, getModifyCls, getModifyName, getPrefixCls, getPrettyCls } from './ConfigContext';
import LocaleContext, { LocaleConsumer, LocaleProvider } from './LocaleContext';
import SizeContext, { SizeConsumer, SizeProvider } from './SizeContext';
import GlobalZIndexContext, { GloablZIndexConsumer, GlobalZIndexProvider, globalZIndex } from './zIndexContext';
import { setRuntimeLocale } from '../Modal/util';
import RatioContext, { RatioConsumer, RatioProvider } from './RatioContext';

var updateRuntimeLocales = function updateRuntimeLocales(config, locale) {
  var getLocale = config.getLocale;
  setRuntimeLocale(getLocale(locale, 'Modal'));
};
/**
 * @desc 全局化配置
 * @link https://bedrock.netease.com/components/configProvider
 */


var GlobalConfigProvider = function GlobalConfigProvider(props) {
  var renderProvider = function renderProvider(context, defaultLocale) {
    var children = props.children,
        propLocale = props.locale,
        localeMessages = props.localeMessages,
        prefixCls = props.prefixCls,
        size = props.size,
        ratio = props.ratio,
        rest = _objectWithoutProperties(props, _excluded);

    var config = _objectSpread(_objectSpread(_objectSpread({}, context), rest), {}, {
      getLocale: function getLocale(locale, componentName) {
        var zhLocales = context.getLocale('zh-CN', componentName);
        var presetLocales = context.getLocale(locale, componentName);

        var propLocales = _get(localeMessages, [locale, componentName]);

        return presetLocales ? _merge({}, presetLocales, propLocales) : _merge({}, zhLocales, propLocales);
      },
      getPrefixCls: getPrefixCls(prefixCls),
      getPrettyCls: getPrettyCls(prefixCls)
    });

    var locale = propLocale || defaultLocale;
    updateRuntimeLocales(config, locale);
    return /*#__PURE__*/React.createElement(RatioProvider, {
      value: ratio || 1
    }, /*#__PURE__*/React.createElement(GlobalZIndexProvider, {
      value: globalZIndex
    }, /*#__PURE__*/React.createElement(SizeProvider, {
      value: size
    }, /*#__PURE__*/React.createElement(LocaleProvider, {
      value: locale
    }, /*#__PURE__*/React.createElement(ConfigProvider, {
      value: config
    }, children)))));
  };

  return /*#__PURE__*/React.createElement(LocaleConsumer, null, function (locale) {
    return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (context) {
      return renderProvider(context, locale);
    });
  });
};

Object.assign(GlobalConfigProvider, {
  ConfigConsumer: ConfigConsumer,
  ConfigContext: ConfigContext,
  LocaleConsumer: LocaleConsumer,
  LocaleContext: LocaleContext,
  SizeConsumer: SizeConsumer,
  SizeContext: SizeContext,
  GloablZIndexConsumer: GloablZIndexConsumer,
  GlobalConfigProvider: GlobalConfigProvider,
  GlobalZIndexContext: GlobalZIndexContext,
  getModifyCls: getModifyCls,
  getModifyName: getModifyName,
  RatioContext: RatioContext,
  RatioConsumer: RatioConsumer
});
export { ConfigConsumer, ConfigContext, LocaleConsumer, LocaleContext, SizeConsumer, SizeContext, GloablZIndexConsumer, GlobalConfigProvider, GlobalZIndexContext, getModifyCls, getModifyName, RatioContext, RatioConsumer };
export default GlobalConfigProvider;